import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded'
import {
  Avatar,
  Box,
  Divider,
  ListItemIcon,
  Menu,
  MenuItem,
  Stack,
  Typography,
  ButtonBase,
} from '@mui/material'
import { useState, type MouseEvent } from 'react'
import { useNavigate } from 'react-router-dom'

import { useAuth } from '@/features/auth/hooks/useAuth'
import { ROLE_LABELS } from '@/features/auth/constants'
import { paths } from '@/routes/paths'

function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/)
  const first = parts[0]?.[0] ?? ''
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? '') : ''
  return (first + last).toUpperCase()
}

export function UserMenu() {
  const { user, logout } = useAuth()
  const navigate = useNavigate()
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  if (!user) return null

  const handleOpen = (event: MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget)
  const handleClose = () => setAnchorEl(null)

  const handleLogout = async () => {
    handleClose()
    await logout()
    navigate(paths.login, { replace: true })
  }

  return (
    <>
      <ButtonBase
        onClick={handleOpen}
        sx={{ borderRadius: 999, p: 0.5, pr: 1.5, display: 'flex', alignItems: 'center', gap: 1 }}
      >
        <Avatar sx={{ width: 34, height: 34, bgcolor: 'primary.main', fontSize: '0.8rem' }}>
          {initialsOf(user.full_name)}
        </Avatar>
        <Box sx={{ textAlign: 'left', display: { xs: 'none', sm: 'block' } }}>
          <Typography variant="body2" sx={{ fontWeight: 600, lineHeight: 1.2 }}>
            {user.full_name}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {ROLE_LABELS[user.role]}
          </Typography>
        </Box>
      </ButtonBase>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{ paper: { sx: { minWidth: 220, mt: 1 } } }}
      >
        <Stack sx={{ px: 2, py: 1.5 }}>
          <Typography variant="body2" noWrap sx={{ fontWeight: 600 }}>
            {user.full_name}
          </Typography>
          <Typography variant="caption" color="text.secondary" noWrap>
            {user.email}
          </Typography>
        </Stack>
        <Divider />
        <MenuItem onClick={handleLogout} sx={{ color: 'error.light' }}>
          <ListItemIcon sx={{ color: 'error.light' }}>
            <LogoutRoundedIcon fontSize="small" />
          </ListItemIcon>
          Cerrar sesión
        </MenuItem>
      </Menu>
    </>
  )
}
